"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styles_1 = require("@mui/material/styles");
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const ArrowBack_1 = __importDefault(require("@mui/icons-material/ArrowBack"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Section_1 = __importDefault(require("./Section"));
const InputLabel_1 = __importDefault(require("@mui/material/InputLabel"));
const MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
const FormControl_1 = __importDefault(require("@mui/material/FormControl"));
const Select_1 = __importDefault(require("@mui/material/Select"));
const TextField_1 = __importDefault(require("@mui/material/TextField"));
const DatePicker_1 = __importDefault(require("@mui/lab/DatePicker"));
const AdapterDateFns_1 = __importDefault(require("@mui/lab/AdapterDateFns"));
const LocalizationProvider_1 = __importDefault(require("@mui/lab/LocalizationProvider"));
const ru_1 = __importDefault(require("date-fns/locale/ru"));
const immer_1 = __importDefault(require("immer"));
const material_1 = require("@mui/material");
const model_1 = require("../../model");
const HitTypeSelect_1 = __importDefault(require("./HitTypeSelect"));
/**
 * War period.
 */
const Period = {
    from: new Date(1941, 5, 21),
    to: new Date(1945, 4, 9),
};
const SidebarBody = (0, styles_1.styled)("div")(({ theme }) => ({
    padding: theme.spacing(2),
    width: "min(70vw, 300px)",
}));
const SidebarHeader = (0, styles_1.styled)("div")({
    display: "flex",
    alignItems: "center",
    width: "100%",
});
const Title = (0, styles_1.styled)(Typography_1.default)(({ theme }) => ({
    marginLeft: theme.spacing(1),
}));
const SidebarSection = (0, styles_1.styled)(Section_1.default)(({ theme }) => ({
    marginTop: theme.spacing(4),
}));
const Field = (0, styles_1.styled)("div")(({ theme }) => ({
    display: "block",
    width: "100%",
    marginBottom: theme.spacing(2),
}));
function Sidebar(props) {
    const { options, onChange, onBack, className } = props;
    const handleAddrType = (0, react_1.useCallback)((event) => onChange((0, immer_1.default)(options, (updated) => {
        updated.hit.addrType = event.target.value;
    })), [options, onChange]);
    const handleStreet = (0, react_1.useCallback)((event) => onChange((0, immer_1.default)(options, (updated) => {
        updated.hit.street = event.target.value;
    })), [options, onChange]);
    const handleHouseNum = (0, react_1.useCallback)((event) => onChange((0, immer_1.default)(options, (updated) => {
        const houseNum = Number(event.target.value);
        if (!isNaN(houseNum) && houseNum >= 1) {
            updated.hit.houseNumber = Math.floor(houseNum);
        }
        else {
            updated.hit.houseNumber = null;
        }
    })), [options, onChange]);
    const handleMinDate = (0, react_1.useCallback)((minDate) => onChange((0, immer_1.default)(options, (updated) => {
        updated.hit.minDate = minDate;
    })), [options, onChange]);
    const handleMaxDate = (0, react_1.useCallback)((maxDate) => onChange((0, immer_1.default)(options, (updated) => {
        updated.hit.maxDate = maxDate;
    })), [options, onChange]);
    const handleShowFrontLine = (0, react_1.useCallback)((event) => onChange((0, immer_1.default)(options, (updated) => {
        updated.frontLine.show = event.target.checked;
        if (!event.target.checked) {
            updated.frontLine.date = null;
        }
    })), [options, onChange]);
    const handleTypes = (0, react_1.useCallback)((newTypes) => onChange((0, immer_1.default)(options, (updated) => {
        updated.hit.types = newTypes;
    })), [options, onChange]);
    const handleFrontDate = (0, react_1.useCallback)((date) => onChange((0, immer_1.default)(options, (updated) => {
        updated.frontLine.date = date;
    })), [options, onChange]);
    return (react_1.default.createElement(SidebarBody, { className: className },
        react_1.default.createElement(LocalizationProvider_1.default, { dateAdapter: AdapterDateFns_1.default, locale: ru_1.default },
            react_1.default.createElement(SidebarHeader, null,
                react_1.default.createElement(material_1.Tooltip, { title: "\u041D\u0430\u0437\u0430\u0434" },
                    react_1.default.createElement(IconButton_1.default, { onClick: onBack },
                        react_1.default.createElement(ArrowBack_1.default, null))),
                react_1.default.createElement(Title, { variant: "h5" }, "\u041F\u043E\u0438\u0441\u043A")),
            react_1.default.createElement(SidebarSection, { title: "\u0410\u0434\u0440\u0435\u0441" },
                react_1.default.createElement(Field, null,
                    react_1.default.createElement(FormControl_1.default, { fullWidth: true },
                        react_1.default.createElement(InputLabel_1.default, null, "\u0418\u0441\u043A\u0430\u0442\u044C"),
                        react_1.default.createElement(Select_1.default, { value: options.hit.addrType, label: "\u0418\u0441\u043A\u0430\u0442\u044C", onChange: handleAddrType },
                            react_1.default.createElement(MenuItem_1.default, { value: model_1.AddressType.MODERN }, "\u0421\u043E\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u044B\u0439 \u0430\u0434\u0440\u0435\u0441"),
                            react_1.default.createElement(MenuItem_1.default, { value: model_1.AddressType.HISTORIC }, "\u0418\u0441\u0442\u043E\u0440\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u0430\u0434\u0440\u0435\u0441")))),
                react_1.default.createElement(Field, null,
                    react_1.default.createElement(TextField_1.default, { label: "\u0423\u043B\u0438\u0446\u0430", variant: "outlined", fullWidth: true, value: options.hit.street || "", onChange: handleStreet })),
                react_1.default.createElement(Field, null,
                    react_1.default.createElement(TextField_1.default, { label: "\u0414\u043E\u043C", variant: "outlined", type: "number", fullWidth: true, value: options.hit.houseNumber || "", onChange: handleHouseNum }))),
            react_1.default.createElement(SidebarSection, { title: "\u0414\u0430\u0442\u0430" },
                react_1.default.createElement(Field, null,
                    react_1.default.createElement(DatePicker_1.default, { views: ["day"], label: "\u041E\u0442", value: options.hit.minDate, onChange: handleMinDate, renderInput: (params) => (react_1.default.createElement(TextField_1.default, Object.assign({}, params, { helperText: null, fullWidth: true }))), minDate: Period.from, maxDate: options.hit.maxDate || Period.to, defaultCalendarMonth: Period.from, mask: "__.__.____" })),
                react_1.default.createElement(Field, null,
                    react_1.default.createElement(DatePicker_1.default, { views: ["day"], label: "\u0414\u043E", value: options.hit.maxDate, onChange: handleMaxDate, renderInput: (params) => (react_1.default.createElement(TextField_1.default, Object.assign({}, params, { helperText: null, fullWidth: true }))), minDate: options.hit.minDate || Period.from, maxDate: Period.to, defaultCalendarMonth: Period.to, mask: "__.__.____" }))),
            react_1.default.createElement(SidebarSection, { title: "\u0422\u0438\u043F \u041F\u043E\u043F\u0430\u0434\u0430\u043D\u0438\u044F" },
                react_1.default.createElement(Field, null,
                    react_1.default.createElement(HitTypeSelect_1.default, { types: options.hit.types || [], onChange: handleTypes }))),
            react_1.default.createElement(SidebarSection, { title: "\u041B\u0438\u043D\u0438\u044F \u0424\u0440\u043E\u043D\u0442\u0430" },
                react_1.default.createElement(Field, null,
                    react_1.default.createElement(material_1.FormControlLabel, { control: react_1.default.createElement(material_1.Checkbox, { checked: options.frontLine.show, onChange: handleShowFrontLine }), label: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u043B\u0438\u043D\u0438\u044E \u0444\u0440\u043E\u043D\u0442\u0430" })),
                react_1.default.createElement(Field, null,
                    react_1.default.createElement(DatePicker_1.default, { views: ["day"], label: "\u041D\u0430 \u043C\u043E\u043C\u0435\u043D\u0442", value: options.frontLine.date, onChange: handleFrontDate, renderInput: (params) => (react_1.default.createElement(TextField_1.default, Object.assign({}, params, { helperText: null, fullWidth: true }))), minDate: Period.from, maxDate: Period.to, defaultCalendarMonth: Period.from, mask: "__.__.____" }))))));
}
exports.default = Sidebar;
